import { IconQuestionCircleOutlined } from "@suse-o11y/icons";
import isError from "lodash/isError";
import React from "react";

import { Modal, type ModalFuncProps } from "./Modal";

export class ModalConfirmError extends Error {}

ModalConfirmError.prototype.name = "ModalConfirmError";

export const modalConfirmCancellable = (
	message: string,
	options: ModalFuncProps = {},
): Promise<boolean | ModalConfirmError> => {
	const onOkOpts = options.onOk;
	const onCancelOpts = options.onCancel;
	return new Promise((resolve) => {
		Modal.confirm({
			...options,
			centered: true,
			zIndex: 1050,
			title: message,
			okText: "Yes",
			cancelText: "No",
			onOk: (...args: Array<unknown>) => {
				onOkOpts?.(...args);
				resolve(true);
			},
			onCancel: (...args: Array<unknown>) => {
				const [meta] = args;
				onCancelOpts?.(...args);
				// this is how antd is detecting cancellable behavior
				if (meta && typeof meta === "object" && "triggerCancel" in meta && meta.triggerCancel) {
					resolve(new ModalConfirmError("Canceled"));
				} else {
					resolve(false);
				}
			},
		});
	});
};

/*
 * Basic confirmation modal which returns true/false only
 * and has Esc button action returning false
 */
export const yesNoModalConfirm = async (message: string, options: ModalFuncProps = {}): Promise<boolean> => {
	const result = await modalConfirmCancellable(message, {
		...options,
		okText: "OK",
		cancelText: "Cancel",
		okButtonProps: { danger: true },
	});
	if (isError(result)) {
		return false;
	}
	return result;
};

export const modalDelete = (message: string): Promise<boolean> =>
	new Promise<boolean>((resolve) => {
		Modal.confirm({
			className: "delete-modal",
			icon: <IconQuestionCircleOutlined />,
			centered: true,
			title: message,
			okText: "Yes",
			okButtonProps: { danger: true },
			autoFocusButton: "ok",
			cancelText: "No",
			onOk: () => void resolve(true),
			onCancel: () => void resolve(false),
		});
	});
